// styling
import styles from "./DocumentsPage.module.scss";

// components
import PageHeader from "@layout/PageHeader";
import DocumentCard from "@components/DocumentCard";

// Página de documentos. `documents` es la lista del torneo (dianDocuments, formatosDocuments…):
// [{ name, detail, file }], en el orden en que se muestran.
const DocumentsPage = ({ title, documents }) => {
  return (
    <>
      <PageHeader title={title} />
      <div className={styles.grid}>
        {documents.map((document, index) => (
          <DocumentCard key={document.file} index={index} {...document} />
        ))}
      </div>
    </>
  );
};

export default DocumentsPage;
